export default "__VITE_ASSET__08315c1b__"